import WhatsappBackground from "@/assets/login/1.svg";
import SalesmanMessage from "@/assets/login/21.png";
import MDBox from "@/components/atoms/MDBox";
import colors from "@/themes/base/colors";

const { gradients } = colors;

const RightContent = () => {
  return (
    <MDBox position={"relative"} height={"100%"} sx={{ backgroundColor: gradients.dark.main }}>
      <MDBox
        style={{
          position: "absolute",
          top: "50%",
          left: "0",
          transform: "translate(-40%, -50%)",
          height: "90%",
          width: "90%",
          zIndex: 1,
        }}
      >
        <img
          src={WhatsappBackground}
          alt="WhatsApp Background"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </MDBox>

      <MDBox
        style={{
          position: "absolute",
          top: "72%",
          right: "25%",
          transform: "translate(40%, -50%)",
          height: "auto",
          width: "40%",
          zIndex: 2,
        }}
      >
        <img
          src={SalesmanMessage}
          alt="Steps Image"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </MDBox>
    </MDBox>
  );
};

export default RightContent;
